module.exports = __webpack_public_path__ + "static/media/folder.26eb5ba1.svg";